export default __webpack_public_path__ + "static/media/mozart.6e966921.mp3";